import { studioDomain } from '@/environment';
import Cookies from 'js-cookie';
import type { LDSingleKindContext } from 'launchdarkly-js-client-sdk';
import { crossSiteDomain } from './utils';

export type TrackId = {
    kind: string;
    key?: string;
    anonymous?: boolean;
    email?: string;
    org_id?: string;
    plan_group?: string;
    createdAt: Date;
    createdBy: string;
};

const TRACK_ID_COOKIE_KEY: string = 'trackId';

export const getTrackIdFromLDContext = (context: LDSingleKindContext): TrackId => {
    return {
        kind: context.kind,
        key: context.key,
        anonymous: context.anonymous,
        email: context.email,
        org_id: context.org_id,
        plan_group: context.plan_group,
        createdAt: new Date(),
        createdBy: studioDomain,
    };
};

export const setTrackIdOnSharedCookie = (trackId: TrackId) => {
    Cookies.set(TRACK_ID_COOKIE_KEY, JSON.stringify(trackId), { domain: crossSiteDomain });
};
